// Copyright 2022, Imprivata, Inc.  All rights reserved.
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
export interface DateOfBirthProps {
  dateOfBirth?: string;
}
const DateOfBirth = (props: DateOfBirthProps & { 'data-testid'?: string }) => {
  const { t, i18n } = useTranslation();
  const testId = props['data-testid'] || undefined;
  const calculateAge = (dob: Date): number => {
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  };
  const dateOfBirth = new Date(props.dateOfBirth || '');
  if (dateOfBirth && Number.isNaN(dateOfBirth.getTime())) {
    return (
      <Typography.Text className="text-center d-block" data-testid={testId}>{t('dateOfBirth.-')}</Typography.Text>
    );
  }
  const age = calculateAge(dateOfBirth);
  if (props.dateOfBirth) {
    return (
      <Typography.Text className="text-center d-block" data-testid={testId}>
        {dateOfBirth.toLocaleDateString(
          i18n.language === 'es' || i18n.language === 'es-MX' ? 'es-MX' : 'en-US',
          {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          timeZone: 'UTC',
          },
        )}
        {age ? ` (${t('dateOfBirth.age-value', { count: age })})` : ''}
      </Typography.Text>
    );
  }
  return (
    <Typography.Text className="text-center d-block" data-testid={testId}>{t('dateOfBirth.-')}</Typography.Text>
  );
};
export default DateOfBirth;
